import Base from '../../js/_base';
import bootstrapBreakpoints from '../../plugins/grid';

let $document, $body, $window;
export default class NoScroll extends Base {
    get selectors() {
        return {
            toggles: '.js--add-noscroll, .js--remove-noscroll',
        };
    }

    get classList() {
        return {
            noScroll: 'overflow-hidden',
            add: 'js--add-noscroll',
        };
    }

    get elements() {
        return {
            toggles: [],
        };
    }

    constructor() {
        super();
        $document = $(document);
        $body = $('body');
        $window = $(window);
        this.vPort = 'sm';
        this.initialize();
        this.addEventListeners();
    }

    initialize() {
        super.initialize();
        this._elements.toggles = document.querySelectorAll(this._selectors.toggles);
    }

    addEventListeners() {
        super.addEventListeners();

        this._elements.toggles.forEach(toggle => {
            toggle.addEventListener('click', this.onClick.bind(this, toggle));
        });
        this.setViewPortListeners(`screen-${this.vPort}`);
    }

    onClick(toggle) {
        if (bootstrapBreakpoints[this.vPort] < $window.width()) {
            this.noScrollToggled = !this.noScrollToggled;
            return;
        }
        this.toggleNoScroll(toggle);
    }

    toggleNoScroll(toggle) {
        const {noScroll, add} = this._classList;
        if (toggle.classList.contains(add)) {
            $body.addClass(noScroll);
        } else {
            $body.removeClass(noScroll);
        }
        this.noScrollToggled = $body.hasClass(noScroll);
    }

    setViewPortListeners(viewPort) {
        $document.on(viewPort + '-on', this.onViewPort.bind(this)).on(viewPort + '-off', this.offViewPort.bind(this));
    }

    onViewPort() {
        if (this.noScrollToggled) {
            $body.addClass(this._classList.noScroll);
        }
    }

    offViewPort() {
        $body.removeClass(this._classList.noScroll);
    }
}
